import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { unstable_renderSubtreeIntoContainer } from 'react-dom';
import useFetch from 'CustomHooks/useFetch';
import { validateEmail } from '../../Util/ValidateEmail';

export default function PaynetSubscriptionForm(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [radioValue, setRadioValue] = useState('');
    const [nameOnCard, setNameOnCard] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [errorClass, setErrorClass] = useState({});
    const [getRedirectLinkHookResponse, getRedirectLinkHook] = useFetch();


    useEffect(
        () => {
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: '8',
                        b: '101',
                    },
                }
            )
        }, []
    )

    const validate = () => {

        let tempErrorClass = {};
        let errorExist = false;

        if (nameOnCard == '') {
            tempErrorClass.nameOnCard = true;
            errorExist = true;
        }
        else {
            tempErrorClass.nameOnCard = false;
        }

        if (email == '') {
            tempErrorClass.email = true;
            errorExist = true;
        }
        else {
            tempErrorClass.email = false;
            if (!validateEmail(email)) {
                tempErrorClass.email = true;
                errorExist = true;
            }
        }

        if (phoneNumber == '') {
            tempErrorClass.phoneNumber = true;
            errorExist = true;
        }
        else {
            tempErrorClass.phoneNumber = false;
        }

        if (radioValue == '') {
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Lütfen Gelişmiş 30 veya Gelişmiş 50 paketlerinden birini seçin.', showButton: true } });
            errorExist = true;
        }


        setErrorClass({ ...tempErrorClass });
        return errorExist;
    }

    const submit = () => {
        if (validate()) {
            return;
        }
        else {
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Kontrol ediliyor...', showButton: false } });
            getRedirectLinkHook(
                {
                    url: '/admin/paynet/create-paynet-subscription',
                    addTokenHeader: true,
                    method: 'POST',
                    postData: {
                        "name": nameOnCard,
                        "email": email,
                        "gsm": phoneNumber,
                        "subscriptionPlan": radioValue,
                    },
                }
            )
        }
    }

    useEffect(
        () => {
            if (getRedirectLinkHookResponse.redirectUrl) {
                globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Ödeme için PAYNET ödeme sistemine aktarılıyorsunuz', showButton: false } });
                setTimeout(() => {
                    globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
                    window.location = getRedirectLinkHookResponse.redirectUrl;
                }, 3000);

            }
        }, [getRedirectLinkHookResponse]
    )
    return (
        <div className={classes.root}>
            <div onClick={() => setRadioValue('GELISMIS_30')} className={classes.package} style={{ backgroundColor: radioValue == '30' ? 'aliceblue' : 'white' }}>
                <div className={classes.badge}>
                    <span>
                        Gelişmiş
                    </span>
                    <span>
                        30
                    </span>
                    <span>
                        
                    </span>
                </div>
                <div className={classes.col2}>
                    <div>
                        30 Masaya kadar bütün özellikleri kullanın
                    </div>
                    <div>
                    149 TL / Aylık
                    </div>
                </div>
                <Radio
                    checked={radioValue === 'GELISMIS_30'}
                    onChange={() => setRadioValue('GELISMIS_30')}
                    value="GELISMIS_30"
                    name="radio-button-demo"

                />
            </div>

            <div onClick={() => setRadioValue('GELISMIS_50')} className={classes.package} style={{ backgroundColor: radioValue == '50' ? 'aliceblue' : 'white' }}>
                <div className={classes.badge}>
                    <span>
                        Gelişmiş
                </span>
                    <span>
                        50
                </span>
                </div>
                <div className={classes.col2}>
                    <div>
                        50 Masaya kadar bütün özellikleri kullanın
                    </div>
                    <div>
                    229 TL / Aylık
                    </div>
                </div>
                <Radio
                    checked={radioValue === 'GELISMIS_50'}
                    onChange={() => setRadioValue('GELISMIS_50')}
                    value="GELISMIS_50"
                    name="radio-button-demo"

                />
            </div>

            <TextField error={errorClass.nameOnCard} id="standard-basic" label="Kart üzerindeki isim" onChange={(e) => setNameOnCard(e.target.value)} value={nameOnCard} />
            <TextField error={errorClass.email} id="standard-basic" label="E-posta" onChange={(e) => setEmail(e.target.value)} value={email} />
            <TextField placeholder="5xx xxx xx xx" type="number" error={errorClass.phoneNumber} id="standard-basic" label="Cep telefonu numarası" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} />

            <Button className={classes.buton} color="primary" component="span" variant="contained" onClick={() => { submit() }}>
                Abonelik ödemesine geç
            </Button>




        </div>
    )
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '500px',

        '& > div': {
            marginTop: '20px',
            //width: '300px',
        }
    },
    buton: {
        alignSelf: 'flex-end',
        marginTop: '30px',
    },
    badge: {
        "backgroundColor": "#168da9",
        "color": "white",
        "borderRadius": "5px",
        "display": "flex",
        "flexDirection": "column",
        padding: '10px',


        '& > span:nth-child(2)': {
            fontSize: '2rem',
            alignSelf: 'flex-end',
        }
    },
    package: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #1ba0bf',
        borderRadius: '5px',
        padding: '10px',
        marginTop: '20px',

        '& > div:nth-child(2)': {
            padding: '10px',
        }
    },
    col2: {
        '& > div:nth-child(2)':{"marginTop":"10px","opacity":"0.8","fontWeight":"700"},
    }
});